module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recordInterview":"Записать собеседование"}}')
  delete Component.options._Ctor
}
